import { render, staticRenderFns } from "./sms-code.vue?vue&type=template&id=915a5d12&scoped=true&"
import script from "./sms-code.vue?vue&type=script&lang=js&"
export * from "./sms-code.vue?vue&type=script&lang=js&"
import style0 from "./sms-code.vue?vue&type=style&index=0&id=915a5d12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915a5d12",
  null
  
)

export default component.exports